export default "__VITE_ASSET__D6jY91Q0__"